import { render, staticRenderFns } from "./SelectPos.vue?vue&type=template&id=18e95fc9"
import script from "./SelectPos.vue?vue&type=script&lang=js"
export * from "./SelectPos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports